<template>
    <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2" >		
    <p style="margin-bottom: 0"><a href="#/" class="btn_side" style="margin-bottom: 0">My Menu</a></p>
    <div class="box_style_1">
        <ul id="cat_nav">
            <li>
                <router-link to="/profile">My Orders</router-link>
                <router-link to="/account">My Account</router-link>
            </li>
        </ul>
    </div>
    </div> 
</template>
<script>
export default {
    name: 'profileNav',
    created() {
      console.log(this.$route.name)
    },
}
</script>
<style scoped>
    
    .router-link-active, .router-link-exact-active
    {
    background-color: #deebd1;
    cursor: pointer;
    }
</style>